import React from 'react';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FollowUpButton from '../../FollowUpButton/FollowUpButton';
import ContentBox from '../../ContentBox/ContentBox';

export const ResultSection = ({ intl, options, onGoToLazyPack, text }) => {
  const theme = useTheme();

  return (
    <>
      <Grid style={{ marginBottom: 12 }}>
        {options?.length > 0 && <span style={{ fontSize: 16 }}>{intl.formatMessage({ id: 'choice' })}</span>}
        {options.map((option, index) => (
          <FollowUpButton
            key={option.id}
            onClick={() => onGoToLazyPack(option.id, option.personalized_message)}
            color="primary"
            style={{ color: theme.palette.primary.main, marginLeft: 10 }}
          >
            {intl.formatMessage({ id: 'option-number' }, { number: index + 1 })}
          </FollowUpButton>
        ))}
      </Grid>
      <Grid size={12}>
        <ContentBox text={text} disableCopy />
      </Grid>
    </>
  );
};

export default ResultSection;
